import { PromptTemplateCategory } from '../types';

export const creative: PromptTemplateCategory = {
  title: "Kreativ",
  icon: "✨",
  templates: [
    {
      title: "Gute-Nacht-Geschichte",
      content: `Erstellen Sie eine sanfte Gute-Nacht-Geschichte für ein kleines Kind, geschrieben zum Vorlesen.
- Die Hauptfigur ist [ein freundlicher kleiner Fuchs] namens [Hasel].
- Die Geschichte spielt in [einem gemütlichen Walddorf, in dem nachts Laternen leuchten].
- Die Figur steht vor einer kleinen, beruhigenden Herausforderung: [sie kann ihren Lieblingsstern am bewölkten Himmel nicht finden und folgt daher Glühwürmchen auf eine Hügelspitze].
- Enden Sie mit einer friedlichen Lösung, die lehrt: [Geduld und das Vertrauen, dass gute Dinge noch da sind, auch wenn man sie nicht sehen kann].
- Verwenden Sie kurze, rhythmische Sätze, die beim Vorlesen natürlich klingen.`
    },
    {
      title: "Kurzgeschichten-Erzählung",
      content: `Schreiben Sie eine Kurzgeschichte, die für eine Hörbuch-Erzählung geeignet ist.
- Genre: [zeitgenössischer Krimi].
- Die Protagonistin ist [eine pensionierte Bibliothekarin, die etwas Seltsames an der täglichen Routine des neuen Nachbarn bemerkt].
- Die zentrale Spannung besteht aus [kleinen, unerklärlichen Details, die sich zu einer überraschenden, aber befriedigenden Enthüllung aufbauen].
- Ton: [ruhige Spannung mit Wärme].
- Schreiben Sie in einem klaren, fließenden Stil mit abwechslungsreichen Satzlängen, um das Interesse der Zuhörer zu halten.`
    },
    {
      title: "Gedicht-Lesung",
      content: `Schreiben Sie ein Gedicht, das laut vorgetragen werden soll.
- Thema: [das Gefühl einer Stadt, die im Morgengrauen erwacht].
- Stil: [freier Vers mit natürlichem Sprechrhythmus].
- Stimmung: [nachdenklich und hoffnungsvoll].
- Fügen Sie lebendige sensorische Details ein: [das Geräusch des ersten Busses, Licht auf nassem Pflaster, der Duft von frischem Brot aus einer Bäckerei].
- Verwenden Sie Pausen und Zeilenumbrüche, die das Tempo und die Atmung des Lesers leiten.`
    }
  ]
};
